module.exports = __webpack_public_path__ + "static/media/G.c7fdecee.png";